import ScopedBlogEdit from '@/components/blog/scoped-blog-edit';
import { ROUTES } from '@/config/routes';
import { adminSidebar } from '@/config/sidebarConfig';

export default function AdminBlogEdit() {
  return <ScopedBlogEdit sidebarConfig={adminSidebar} listRoute={ROUTES.ADMIN_BLOG} showCategoryManager showFeatured />;
}
